import React from 'react';

export default function ProjectsFilter({ categories, activeCategory, onCategoryChange }) {
  return (
    <div className="flex flex-wrap items-center gap-[12px] mb-[40px]">
      {categories.map((category, index) => (
        <button
          key={index}
          onClick={() => onCategoryChange(category)}
          className={`px-[16px] py-[8px] rounded-lg font-medium text-[14px] transition-all duration-300 border-[1px] border-solid ${
            activeCategory === category
              ? "bg-[#f1833b] text-white border-transparent"
              : "bg-[#0f0f0fd9] text-[#9ca3af] border-[#ffffff3b] hover:text-white hover:bg-[#1a1a1a]"
          }`}
        >
          {category}
        </button>
      ))}
    </div>
  );
}
